export default (): boolean => typeof document === 'undefined'
